export const help = {
  help: {
    title1: "您好",
    title2: "请问有什么可以帮助你的",
    title3: "推荐阅读",
    searchPlaceholder: "请输入搜索内容",
    list: [
      {
        name: "关于我们",
        children: [
          {
            name: "品牌介绍",
            type: 1,
          },
          {
            name: "商务合作",
            type: 2,
          },
        ],
      },
      {
        name: "帮助中心",
        children: [
          {
            name: "玩转爱答卷",
            type: 3,
          },
          {
            name: "账户问题",
            type: 4,
          },
          {
            name: "调查问题",
            type: 5,
          },
          {
            name: "兑换问题",
            type: 6,
          },
          {
            name: "其他问题",
            type: 7,
          },
        ],
      },
    ],
    content1: [
      {
        title1: "1.关于爱答卷",
        pList: [
          {
            name: "1.广泛的用户参与：爱答卷为广大网民提供了参与调查和发表意见的机会。任何用户都可以注册并参与各种调查项目，表达自己的观点和意见。",
          },
          {
            name: "2.趣味性和有报酬的调查项目：爱答卷提供趣味性的调查项目，使用户的参与更加有趣和愉悦。同时，用户参与调查还可以获得一定的报酬。",
          },
          {
            name: "3.快速有效的沟通渠道：为消费者和企业之间提供了快速有效的沟通渠道。消费者可以直接向企业反馈意见和建议，企业也可以通过爱答卷了解消费者的需求和反馈。",
          },
          {
            name: "4.专业水平的在线市场调研：爱答卷拥有专业的团队和技术，能够为企业提供高质量的在线市场调研服务。通过各种调查方法和工具，帮助企业获取准确、全面的市场信息，为企业决策提供有力的参考依据。",
          },
        ],
      },
    ],
    content2: [
      {
        title1: "联系我们",
        pList: [
          {
            name: "如有需要请联系我们，希望与您取得进一步沟通和合作洽谈",
          },
          {
            name: "邮箱地址：123456789@163.com",
          },
        ],
      },
    ],
    content3: [
      {
        title1: "1.什么是爱答卷？",
        pList: [
          {
            name: "爱答卷是专业的市场调查网站。我们的问卷来自全球的企业和厂商。当您作答一份问卷，您的观点将被传达到世界各地企业用于改善产品提高服务，甚至 创造新产品。为表达感谢您每参与一次问卷我们将回报您金币奖励，您可以用于兑换现金、手机充值卡、购物卡和礼品等。",
          },
        ],
      },
      {
        title1: "2.爱答卷怎么玩？",
        pList: [
          {
            name: "玩赚爱答卷很简单，只需三步",
          },
          {
            name: "第一步：注册 第二步：参与调查 第三步：获得奖励",
          },
        ],
      },
      {
        title1: "3.遇到问题怎么办？",
        pList: [
          {
            name: "客服邮箱：member@baishulai.com",
          },
        ],
      },
      {
        title1: "4.怎么注册？",
        pList: [
          {
            name: "第一步：未登录状态下，点击首页右上角的“免费注册”按钮，在注册页面填写注册基本信息，信息要真实有效。",
          },
          {
            name: "第二步：在您注册的邮箱里查收邮件，点击邮件里的激活链接完成注册。",
          },
        ],
      },
      {
        title1: "5.注册过程的注意事项。",
        pList: [
          {
            name: "A.注册填写的信息一定要准确，否则不能顺利的兑换奖品。例如出生年月须和身份证上的出生年月一致；所在城市须和IP地址一致等",
          },
          {
            name: "B.同一台电脑不能多次注册。",
          },
          {
            name: "C.爱答卷",
          },
          {
            name: "①请核对手机号码是否正确。",
          },
          {
            name: "③稍等1-2分钟再查收验证码。",
          },
          {
            name: "④若5分钟内没收到验证码，请关注微信公众“爱答卷”说明情况，我们会帮助您完成注册。",
          },
        ],
      },
      {
        title1: "6. 会员等级怎么计算的？",
        pList: [
          {
            name: "会员等级与信用值挂钩。注册时，默认铁牌会员；",
          },
          {
            name: "较差： ≤60时，为铁牌会员；",
          },
          {
            name: "中等： 61≤信用值≤100，为铜牌会员；",
          },
          {
            name: "良好： 101≤信用值≤200，为银牌会员；",
          },
          {
            name: "优秀： 201≤信用值≤500，为金牌会员；",
          },
          {
            name: "钻石： 501≤信用值≤800，为钻石会员；",
          },
          {
            name: "王者： 801≤信用值≤1000，为王者会员；",
          },
          {
            name: "会员级别福利： 根据不同会员级别会有相对的VIP专属活动。",
          },
        ],
      },
    ],
    content4: [
      {
        title1: "1.关于账号管理标准？",
        pList: [
          {
            name: "爱答卷是一家在线调查网站，我们将提供尽量多的问卷给会员们参与，是一个提供大家参与社会市场决策和发表个人观点的平台。如果会员超过6个月没有参与任何调查或者活动，为避免账号闲置，爱答卷有权收回会员账号。在收回账户之前，爱答卷的客服会提前一个月邮件通知您，如果您没有任何回复，我们将默认您认可了。",
          },
        ],
      },
      {
        title1: "2.忘记登陆信息怎么办？",
        pList: [
          {
            name: "A.如果忘记密码，点击“忘记密码” 根据提示操作，找回密码。",
          },
          {
            name: "B.为防止再次忘记密码，在“账号设置”下找到”安全设置”里的修改密码，修改为常用密码。",
          },
          {
            name: "C.忘记账号，关注微信公众号“爱答卷”，将您常用邮箱，手机号码，昵称等信息发送给客服会帮忙找回账户。",
          },
        ],
      },
    ],
    content5: [
      {
        title1: "1.参加商业调查能得到现金奖励，是不是真的？",
        pList: [
          {
            name: "商家在把新产品投入市场之前，一般都会先做个市场调查，了解消费者的意见。而商家愿意为此支付调研费用，所以参加商业调查确确实实可以获得现金奖励。当然，作为参与调查者，您所要做的就是按照自身情况和想法，如实的回答问题。这样当您完成调查后，就可以获得相应的现金报酬。如果该商业调查是即时奖励的，那么当您完成调查后即可获得对应的金币奖励。当然，如果您的答卷被我们工作人员后期审核为不合格，发给您的奖励还会倒扣回来；所以，一定要认真、如实的回答问卷。还有少部分比较特殊的商业调查项目，则需要通过审核后才会发放奖励 。",
          },
        ],
      },
      {
        title1: "2.如何参加商业调查？怎么知道是否有适合自己参加的调查？",
        pList: [
          {
            name: "A.登录网站，点击网站导航部分的“调查中心”， 即可查看是否有您适合参加的商业调查。如果有的话，点击调查标题，即可参加 。",
          },
          {
            name: "B.最及时的方式：每天登录 爱答卷，及时参与调查和活动。",
          },
          {
            name: "C.在邮箱中查收我们的调查邀请邮件，通过邮件中的链接直接作答问卷。有时我们也会通过手机短信通知您参加。",
          },
        ],
      },
      {
        title1: "3.为什么我加入有段时间了，却很少收到调查邀请？",
        pList: [
          {
            name: "爱答卷几乎每天都会有新的商业调查发布，但每个商业调查都有其特定的参加条件，例如年龄、性别、地区、收入等等。所以并不是每个调查，都适合于您。我们只会挑选符合您本人条件的调查，邀请您参加。",
          },
          {
            name: "友情提示：您填写的个人信息越详细越真实，参加商业调查的机会就越大。完成手机验证和邮箱激活，也将有助您获得更多的商业调查机会。",
          },
        ],
      },
      {
        title1: "4.为什么有时参加商业调查，回答了几个问题就被提示中止了？",
        pList: [
          {
            name: "发给您的商业调查，符合您注册时填写的基本信息调查条件，但是在问卷中会有另外的甄别条件。如果您不符合这些甄别条件，就会被迫中止调查。另外，每个商业调查都有参加人数的限制，可能在您参加问卷的时候，系统已经回收了足够的问卷，这同样会导致您无法继续参加调查。 虽然您没能完成问卷，但是做为对您的感谢，系统将会奖励您10个金币。",
          },
        ],
      },
      {
        title1: "5.完成一次商业调查，可以得到多少奖励？",
        pList: [
          {
            name: "根据每份商业调查问卷的耗时长短和条件限制，相应的现金报酬会有不同。通常来说，成功完成一份商业调查问卷的现金报酬，大致在5-50元之间。如果由于条件不符合或人数满员而被中止调查，作为对您的感谢，也会奖励10金币。",
          },
        ],
      },
      {
        title1: "6.参加商业调查的奖励，什么时候发放？",
        pList: [
          {
            name: "商业调查的奖励，分为即时奖励和审核奖励两种。对于即时奖励的商业调查，只要您成功完成调查，就可得到奖励（金币余额的变化，会在您重新登录后看到）；对于审核奖励的商业调查项目，则需要先经过人工审核，确认问卷合格后，再由我们的工作人员统一分配发放。这个周期大致需要15天—30天左右的时间。不过您放心，只要您认真地、有效地完成了该调查，我们的系统就会有记录，金币一定会奖励给您，请耐心等等吧。",
          },
        ],
      },
      {
        title1: "7.为什么我已经完成了商业调查，却没得到奖励？",
        pList: [
          {
            name: "只要您是认真、诚实回答填写并完成问卷，请不用担心，每一个调查结束之后，我们都会统计未能正常加分的用户名单，进行补加金币操作。",
          },
        ],
      },
      {
        title1:
          "8. 回答问卷过程中的注意事项，违反规则将会被扣除奖励甚至封闭账号。",
        pList: [
          {
            name: "A. 作答时间过短，如阅读问卷需要10分钟，但3分钟就答完的。",
          },
          {
            name: "B. 在个人资料中填写的信息与问卷中回答不一致的。",
          },
          {
            name: "C. 作答不认真，不读题，胡乱填写答案的。",
          },
          {
            name: "D. 相同IP，同一IP段回答多次者视为作弊。",
          },
          {
            name: "E. 有明显迹象显示是同一人重复回答者视为作弊。",
          },
          {
            name: "问卷调查是严肃的，只有真实的观点才有助于市场的研究。凡出现以上情节者，我们有权扣除其非法所得金币。情节严重的，我们将删除账户。",
          },
        ],
      },
      {
        title1: "9. 为什么已经完成的问卷后期会被审核不符合条件而被扣除积分？",
        pList: [
          {
            name: "每一个问卷调查，受访者都应该本着认真、诚实、守信的原则回答问卷。在问卷调查结束数据收集以后，我们的客户会对所收集的每一份数据进行审核。如果有发现不认真、不诚实的乱答行为，客户会将这些数据作废，因此后期我们也会将被作废数据所获得奖励从相应用户的账户进行相应扣除，情节严重的我们会双倍扣除奖励或者对此用户账号进行黑名单甚至删除账号处理。数据作废的原则包含但不仅限于以下情况：开放题乱填、回答问卷不认真逻辑前后矛盾、逻辑不合常理、答题时间过短不符合问卷要求时间、答题数据雷同、其他任何可能作弊及刷题的手段。",
          },
        ],
      },
      {
        title1: "10.任务审核不通过的原因有哪些？",
        pList: [
          {
            name: "1、雷同数据：同一用户的不同问题答案雷同，或多个用户答案相似度极高。",
          },
          {
            name: "2、开放题质量差：胡乱回复、文不对题等，导致数据不可用。",
          },
          {
            name: "3、答题质量差：在封闭题上胡乱作答，数据不可用。",
          },
          {
            name: "4、前后逻辑不符：在答卷过程中，前后回答内容有明显的矛盾，举例：前面说自己3个月内购买过牛奶，后面回答近期没有购买过牛奶。",
          },
          {
            name: "PS：以上行为会导致您不能获取奖励，情节严重者还将被拉黑；另外，如果发现用户有技术作弊的嫌疑，我们可能会采取法律手段进行追究。",
          },
        ],
      },
    ],
    content6: [
      {
        title1: "1.微信红包兑换规则。",
        pList: [
          {
            nameFa: "5元微信红包兑换规则",
            name: "10元微信红包/30元微信红包/50元微信红包/100元微信红包 ",
          },
          {
            name: "1、仅限通过爱答卷微信公众号兑换，请关注爱答卷微信公众号。",
          },
          {
            name: "2、所兑换红包将会以红包形式发放到您兑换使用的微信账号，红包24小时内未领取，系统将会自动收回红包，并且会将金币自动返还到您的爱答卷账户。",
          },
          {
            name: "3、最终解释权归爱答卷所有",
          },
        ],
      },
      {
        title1: "2. 支付宝兑换规则。",
        pList: [
          {
            name: "1、您需要完善支付宝信息。",
          },
          {
            name: "2、支付宝订单每周五统一审核发放。",
          },
          {
            name: "3、最终解释权归爱答卷所有",
          },
        ],
      },
    ],
    content7: [
      {
        title1: "1.联系我们",
        type: 1,
        pList: [
          {
            name: "爱答卷社区地址：<a href='http://test.aidajuan.com/home'>http://test.aidajuan.com/home</a><br/>关注微信公众号，回复问题更快:<br/><img src='http://www.sudiaoba.com/images/erw.jpg' /><br>客服邮箱：member@baishulai.com",
          },
        ],
      },
      {
        title1: "2.网站地图",
        type: 1,
        pList: [
          {
            name: "<a href='http://test.aidajuan.com/register'>注册</a> | <a href='http://test.aidajuan.com/login'>登录</a> | <a href='http://test.aidajuan.com/home'>首页</a> | <a href='http://test.aidajuan.com/module/task'>任务</a> | <a href='http://test.aidajuan.com/module/exchange'>兑换</a> | <a href='http://test.aidajuan.com/module/activity'>活动</a> | <a href='http://test.aidajuan.com/module/help'>帮助</a> | <a href='http://test.aidajuan.com/commerce'>商务</a> | <a href='http://test.aidajuan.com/module/home'>我的首页</a> | <a href='http://test.aidajuan.com/module/taskRecord'>任务记录</a> | <a href='http://test.aidajuan.com/module/redemptionHistory'>兑换历史</a> | <a href='http://test.aidajuan.com/module/goldHistory'>金币明细</a> | <a href='http://test.aidajuan.com/module/account'>账户设置</a> | <a href='http://test.aidajuan.com/module/invite'>我的邀请</a> | <a href='http://test.aidajuan.com/module/creditValue'>我的信用值</a>",
          },
        ],
      },
      {
        title1: "3.注册协议",
        pList: [
          {
            name: "【审慎阅读】您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是使用须知、隐私保护和法律责任的相关条款。如您对协议有任何疑问，可向爱答卷客服咨询。 爱答卷隶属于南京百数来信息科技有限公司，是专业的市场调查网站。用户注册、登录、使用爱答卷及相关产品等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。",
          },
          {
            name: "一、注册说明",
          },
          {
            name: "用户须完全同意下列所有服务条款并完成注册程序，才能成为爱答卷的会员。除非另有明确规定，否则爱答卷相关的一切新产品均无条件服从本协议。 ",
          },
          {
            name: "二、服务内容",
          },
          {
            name: "用户成为爱答卷的正式会员后，将不定期的接收到调查问卷，会员可通过登录爱答卷参与问卷。爱答卷也将不定期地通过邮件与用户取得联系，邀请会员参与各种形式的市场调研。会员可以使用爱答卷的金币奖励兑换奖品。",
          },
          {
            name: "三、个人账号管理 ",
          },
          {
            name: "1．爱答卷的注册用户有义务妥善保管和使用在注册服务时获得的账号及密码，并为此账号及密码登入系统后所开始的一连串行为或活动负责。",
          },
          {
            name: "2．用户不应将账号及密码泄漏或提供第三人知悉或出借或转让与他人使用，如因用户自身过错或过失而导致账号或密码泄漏而给用户自身造成损失，用户应自行承担责任。 ",
          },
          {
            name: "3．若用户发现账号或密码遭他人非法使用或有异常使用的情形，应立即通知爱答卷，并提交该账号为本人所有的有关证明，以便申请该账号的暂停使用。因此而造成的损失，爱答卷不承担赔偿责任。",
          },
          {
            name: "4．爱答卷的会员有义务严格按照个人实际情况来填写账号资料，如有发现不符合实际情况的账号，爱答卷有权暂停或终止用户的账号，并拒绝现在或将来使用服务的全部或一部分。",
          },
          {
            name: "5．爱答卷会员不得同时注册多个账号，爱答卷将通过各种技术手段进行技术检查，当发现用户存在多个账号时,爱答卷有权封停账号。 ",
          },
          {
            name: "6．用户注册爱答卷账号后，如果长期不使用，爱答卷有权删除其账号，以免造成资源浪费。",
          },
          {
            name: "四、用户使用须知",
          },
          {
            name: "特别提醒用户，使用互联网必须遵守国家有关的政策和法律，如刑法、国家安全法、保密法、计算机信息系统安全保护条例，保护国家利益;保护国家安全。对于违法或者不当使用互联网络而引起的一切责任，由用户负全部责任和连带责任。",
          },
          {
            name: "1．用户不得使用爱答卷发送或者传播敏感信息或者违反国家法律制度的信息；用户不得使用爱答卷发送或传播虚假、骚扰性、侮辱性、恐吓性、伤害性、挑衅性、庸俗性、淫秽色情性信息。",
          },
          {
            name: "2．爱答卷和大多数因特网网站或应用一样，易受到各种安全问题的困挠，包括：个人资料被盗取，被不法分子利用，造成现实生活中的骚扰；被破译密码；下载安装的其他软件或者文件中含有各种病毒，威胁到个人计算机上信息和数据的安全，进而威胁到爱答卷的使用。 ",
          },
          {
            name: "3．用户应加强个人资料保护意识，以免对个人生活和正常使用爱答卷服务造成不必要的影响。",
          },
          {
            name: "4．盗取他人用户账号，共享和传播非法和不良信息、文件，或利用网络通讯骚扰他人，均属于违法行为。",
          },
          {
            name: "5．违反规则处罚规定。(1)参加调查不认真，没有根据自己本人的意愿如实填写问卷，根据每份问卷的金币情况进行倒扣金币处罚。",
          },
          {
            name: "6．必须遵守问卷保密原则。爱答卷会员必须严格遵守调查保密原则，不允许发布或转发答案、不允许复制问卷内容、不允许为他人做任何的提示，一但发现追究其法律责任。",
          },
          {
            name: "7．注册信息真实无误。用户应保证其提供给爱答卷的资料均为真实无误，不得伪造或利用他人信息进行注册，该资料对于使用爱答卷的服务及兑换各种奖品和现金至关重要。如因用户提供虚假资料或被他人获悉自己的注册资料，从而导致的损失由用户本人承担。",
          },
          {
            name: "五、隐私保护",
          },
          {
            name: "1．会员成功注册后，爱答卷会把会员提供的信息储存在我们的安全数据库里。会员的个人资料会用于确保问卷参加者的比例具有与总人口的代表性，并使用于在个别特定的调查项目时确认出最适合的人选。",
          },
          {
            name: "2．爱答卷将不会在未得到会员同意的情况下公开会员的个人识別资料，不会透过网上调查或以邀请方式来收集个人资料或透露会员的个人资料给他人。",
          },
          {
            name: "3．会员在加入爱答卷后将默认为，爱答卷及其合作伙伴可以在需要时（如邀请会员参加调查或向会员支付奖品等情况时），有权通过电子邮件、短信、电话等会员填写的联络资料联系会员。但是因为网络的非绝对安全性，我们会尽力使用技术手段来保护您的个人信息，但无法确保其绝对的安全性。",
          },
          {
            name: "4．爱答卷收集所得的会员资料是网上调查和研究的其中一部分。这些资料将被综合分析，以集体或统计的报告形式传递给发布调查的公司。每份调查问卷所收集的数据其目的只为进行一次研究，绝对不做任何有关第三方的转发或网络传播！",
          },
          {
            name: "5．参加网上问卷调查，即表示会员承认和同意将其个人资料（例如会员在问卷中的答案及所提供的姓名、电邮地址等）用于市场调查、市场研究分析、內部管理、內部培训等，并同意履行爱答卷用户协议。爱答卷会员的联络资料只能在用来邀请会员参加调查、确认会员所提供的资料真实性或提供给会员有关支付奖金的资料时，通过电子邮件、短信、电话联系会员。会员参加爱答卷的活动是自愿的，有权选择加入和退出。",
          },
          {
            name: "6．参与爱答卷的调查，表示您已同意在符合以上的隐私保护条例下我们对会员个人资料的处理和向其他公司透露这些资料，以及您是14周岁或以上的中国公民。",
          },
          {
            name: "7．为了保护儿童，爱答卷没有意愿邀请儿童加入会员。如果需要儿童参加的调查儿童须在成年人的监督下，并需遵从儿童本人的意愿回答问卷的相关问题。",
          },
          {
            name: "六、法律责任",
          },
          {
            name: "1．我们对爱答卷中所显示的信息或资料的准确性、内容、完整性、合法性、可靠性、可操作性或可用性不承担任何责任。我们对爱答卷中的任何信息或材料的删除、存储失败、错误提供或未及时提供不承担任何责任。我们对爱答卷的安全性、可靠性、及时性和性能不做任何担保。我们对通过爱答卷而获得的任何信息或建议不做任何担保。",
          },
          {
            name: "2．用户理解并同意，用户通过爱答卷获取信息或数据完全出于自己的判断，由自己承担风险，同时将对由下载此类材料或数据而导致的计算机系统损坏或数据损失承担全部责任。除爱答卷条款注明的服务条款外，其他一切因使用爱答卷而引致之任何意外、疏忽、合约毁坏、诽谤、版权或其他知识产权侵犯及其所造成的损失（包括因下载而感染电脑病毒），本站不承担由此引发的法律责任。",
          },
          {
            name: "3．用户理解并同意，在反馈处理服务中，爱答卷的客服及相关工作人员并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，除存在故意外，爱答卷对决定免责。",
          },
          {
            name: "4．爱答卷依法律规定承担基础保障义务，但无法对由于信息网络设备维护、连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，暴乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或因第三方原因而给您造成的损害结果承担责任。",
          },
          {
            name: "5．任何单位或个人认为爱答卷内容可能涉嫌侵犯，应准备好具有法律效应的证明材料，及时与爱答卷取得联系，以便爱答卷迅速做出处理。",
          },
          {
            name: "6．爱答卷会员言论纯属个人观点，网站登载目的在于传递更多信息，并不代表爱答卷赞同其观点和对其真实性负责，爱答卷不承担由此引发的法律责任。",
          },
          {
            name: "7．凡以任何方式登陆爱答卷或直接、间接使用爱答卷资料者，视为自愿接受本协议各项条款的约束。本声明未涉及的问题参见国家有关法律法规，当本声明与国家法律法规冲突时，以国家法律法规为准。",
          },
          {
            name: "七、协议修改及其他",
          },
          {
            name: "1．上述协议条款的解释权和修改权归爱答卷所有。 ",
          },
          {
            name: "2．爱答卷保留随时修改本用户协议的权利，并鼓励您定期检查更新。会员如果不同意服务协议条款的修改，可以主动与我们取得联系或停止使用爱答卷及其相关产品所提供的服务；如果用户继续使用爱答卷及其相关产品，则视为用户已经接受服务协议条款的修改。 ",
          },
          {
           name: "3．本协议条款和爱答卷其他协议服务条款构成完整的协议。本协议条款因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。",
          },
        ],
      },
      {
        title1: "4.隐私政策",
        type: 1,
        pList: [
          {
            name: "尊敬的用户，请您务必仔细阅读爱答卷(以下简称“我们”)政策声明，并确定了解我们对您个人信息的处理规则。请您务必充分理解各条款内容，特别是以加粗、加下划线等形式提示您重点注意的条款。",
          },
          {
            name: "除非您已充分阅读、完全理解并接受本隐私政策所有条款，否则您无权使用我们的的产品或服务。您点击“同意”或“下一步”，或您使用我们的产品或服务，或者以其他任何明示或者默示方式表示接受本隐私政策的，均视为您已阅读并同意签署本隐私政策。本隐私政策即在您与我们之间产生法律效力，成为对双方均具有约束力的法律文件。",
          },
          {
            name: "如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称“监护人”）的陪同下阅读和判断是否同意本隐私政策，并特别注意未成年人使用条款。",
          },
          {
            name: "如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。",
          },
          {
            name: "爱答卷非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《隐私政策》向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息。",
          },
          {
            name: "本政策将帮助您了解以下内容：",
          },
          {
            name: "1．我们如何收集您的个人信息 ",
          },
          {
            name: "2．我们如何使用 Cookie 和同类技术 ",
          },
          {
            name: "3．我们如何使用您的个人信息 ",
          },
          {
            name: "4．我们会如何共享、转让、公开披露您的个人信息",
          },
          {
            name: "5．我们如何保护和保存您的个人信息 ",
          },
          {
            name: "6．您如何管理个人信息",
          },
          {
            name: "7．未成年人信息的保护",
          },
          {
            name: "8．本政策的适用及更新",
          },
          {
            name: "9．如何联系我们 ",
          },
          {
            name: "一、我们如何收集您的个人信息",
          },
          {
            name: "个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括：<strong>基本信息</strong>（包括个人姓名、生日、性别、住址、手机号码、电子邮箱）；<strong>个人身份信息</strong>（包括身份证、军官证、护照、驾驶证等）；<strong>人口学属性信息</strong>（教育程度、职业、收入以及其他市场调研行业需要收集的信息）；<strong>问卷作答信息</strong>（您在参与市场调查问卷时，需要作答问卷中的题目，您可能需要提供下述但不限于如下您的日常信息（产品认知，消费行为等等）；<strong>个人财产信息</strong>（积分、奖品、积分记录、兑换记录等信息）；<strong>个人上网记录</strong>（包括网站浏览记录、软件使用记录、点击记录）；<strong>个人常用设备信息</strong>（包括硬件型号、设备 MAC 地址、IP 地址、操作系统类型、浏览器信息、软件列表唯一设备识别码（如 IMEI、IDFA 等在内的描述个人常用设备基本情况的信息）；<strong>个人位置信息</strong>（精准定位信息、经纬度等）； ",
          },
          {
            name: "1、 您直接提供的信息 ",
          },
          {
            name: "(1)注册",
          },
          {
            name: "在您注册本软件账户或使用本软件服务时，需要提供昵称、头像、手机号码、密码、生日、性别、省份、城市。如您不提供前述信息，可能无法注册账户或无法使用本软件服务。手机号码和密码是您登陆和使用本软件的必要条件，生日、性别、省份、城市信息是您参与市场调查问卷抽样的必须条件。",
          },
          {
            name: "人口学属性信息，是您参与市场调查问卷必要的前提条件，所以除注册信息外，您还需要进一步向我们提供包括但不限于您的如下属性信息（教育程度、职业、收入以及其他市场调研行业需要收集的信息）。",
          },
          {
            name: "(2)问卷作答",
          },
          {
            name: "市场调查问卷就是用科学的方法系统地搜集、记录、整理和分析有关市场的信息资料，从而了解市场发展变化的现状和趋势，为企业经营决策、广告策划、广告写作提供科学的依据。一份比较完善的问卷作答信息通常由以下几部分构成： ",
          },
          {
            name: "a.被调查者的基本情况包括被调查者的年龄、性别、教育程度、职业、住址、收入等。 ",
          },
          {
            name: "b.调查内容本身是指所调查的具体项目，它是问卷的最重要的组成部分。",
          },
          {
            name: "c.调查问卷说明其内容主要包括填表目的和要求，被调查者注意事项，提交时间等。",
          },
          {
            name: "调查内容是用户主要填写的部分，例如：请问你使用过以下哪些品牌的牙膏？ ",
          },
          {
            name: "A 两面针 B 高露洁 C 雅植 ",
          },
          {
            name: "(3)兑换",
          },
          {
            name: "我们首先会核实您的积分合法性，比如是否存在通过作弊，盗取，冒领，重复领取等行为获得积分的情况，当发现积分有异常情况下我们有权拒绝您的兑换申请、并且扣减您非法所得的积分。",
          },
          {
            name: "1、当您使用积分兑换奖品时，根据奖品的差异，需要您提供相应的信息。首先兑换需要认证手机号码真实性，以便于通知您兑换相关信息。兑换卡券等虚拟奖品需要您提供 Email 信息， 以便您接收卡号/卡密等信息。兑换现金类奖品，需要您填写支付宝、身份证、真实姓名、且需要对身份证进行验证，因为我们需要向税务机关进行您的个人所得税申报。<strong>请您一定注意，我们向税务机关进行您的个人所得税申报会直接体现在您的个税记录中，如果您在领取低保，或者您的收入/个税记录与您的其它事项有关系，请切记谨慎操作，以免带来不必要的麻烦，我们不承担由此造成的您个人的任何损失以及任何责任。</strong>实物快递类奖品，至少需要您提供手机号码，收货人姓名，收货地址信息。 ",
          },
          {
            name: "2、自动收集的信息 ",
          },
          {
            name: "为了改进提高我们的产品和服务，同时为了更有针对性和准确的向您推送市场调研活动，以及满足市场调研的项目要求，您同意并授权我们收集您的如下信息：<strong>个人上网记录</strong>（包括网站浏览记录、软件使用记录、点击记录）；<strong>个人常用设备信息</strong>（包括硬件型号、设备 MAC 地址、IP 地址、操作系统类型、浏览器信息、软件列表唯一设备识别码（如 IMEI、IDFA 等在内的描述个人常用设备基本情况的信息）；<strong>个人位置信息</strong>（精准定位信息、经纬度等）； ",
          },
          {
            name: "3、第三方信息 ",
          },
          {
            name: "您可能通过微博、微信、QQ 支付宝等第三方帐号登录本软件，我们可能从第三方获取您授权共享的帐号信息（标识 ID、头像、昵称等），并在您同意本隐私政策后将您的第三方账户与您的本软件帐号绑定，使您可以通过第三方帐号直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。 ",
          },
          {
            name: "二、我们如何使用 Cookie 和同类技术",
          },
          {
            name: "您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。我们使用 Cookie 主要包含以下几种情况： ",
          },
          {
            name: "1、判断注册用户登录状态 ",
          },
          {
            name: "2、提升服务/产品质量，向您提供个性化需求 ",
          },
          {
            name: "3、市场调查问卷项目需求",
          },
          {
            name: "我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。",
          },
          {
            name: "三、我们如何使用您的个人信息",
          },
          {
            name: "1．使用我们的服务时用于身份验证，用户服务和安全防范等；",
          },
          {
            name: "2．个性化服务以及帮助我们设计新服务，提升现有服务体验； ",
          },
          {
            name: "3．市场调研、<strong>广告监测分析以及相关的</strong>数据研究和数据分析；",
          },
          {
            name: "4．日常运营活动；",
          },
          {
            name: "5．根据法律法规或监管要求向相关部门进行报告。",
          },
          {
            name: "四、我们会如何共享、转让、公开披露您的个人信息 ",
          },
          {
            name: "1、共享 ",
          },
          {
            name: "我们不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意， 我们可在以下情况下共享您的个人信息。",
          },
          {
            name: "（1）事先获得您明确的同意或授权；  ",
          },
          {
            name: "（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；",
          },
          {
            name: "（3）只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；",
          },
          {
            name: "（4）应您需求为您处理您与他人的纠纷或争议； ",
          },
          {
            name: "（5）基于学术研究而使用； ",
          },
          {
            name: "共享给我们的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与我们的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。",
          },
          {
            name: "我们可能会向合作伙伴等第三方共享您的某些信息，<strong>如与第三方广告监测服务商共享您的唯一设备识别码用于市场调研、广告监测分析等。</strong>我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时， 我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。 ",
          },
          {
            name: "2、转让 ",
          },
          {
            name: "我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：",
          },
          {
            name: "（1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息； ",
          },
          {
            name: "（2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。 ",
          },
          {
            name: "3、公开披露",
          },
          {
            name: "我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息 ",
          },
          {
            name: "（1）获得您的明确同意；",
          },
          {
            name: "（2）基于法律法规、法律程序、诉讼或政府主管部门强制性要求。但我们保证，在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件。",
          },
          {
            name: "五、我们如何保护和保存您的个人信息",
          },
          {
            name: "我们重视个人信息安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。",
          },
          {
            name: "我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。",
          },
          {
            name: "在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。",
          },
          {
            name: "我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。 ",
          },
          {
            name: "六、您如何管理个人信息",
          },
          {
            name: "我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。",
          },
          {
            name: "1、PC 端，登录后，在<strong>账号设置</strong>中可以修改以下三类信息：账号信息，个人资料和兑换信息。",
          },
          {
            name: "2、手机端，登录后，在<strong>我的</strong>里面可以修改各项个人信息。 ",
          },
          {
            name: "七、未成年人信息的保护",
          },
          {
            name: "1、如果您是 18 周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的书面同意。我们根据国家相关法律法规的规定保护未成年人的个人信息。 ",
          },
          {
            name: "2、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。如您的监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。 ",
          },
          {
            name: "八、本政策的适用及更新",
          },
          {
            name: "本产品所有服务均适用政策明。",
          },
          {
            name: "发生下列重大变化情形时，我们会适时对本政策进行更新： ",
          },
          {
            name: " （1）我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变更；",
          },
          {
            name: "（2）收集、存储、使用个人信息的范围、目的、规则发生变化； ",
          },
          {
            name: "（3）对外提供个人信息的对象、范围、目的发生变化； ",
          },
          {
            name: "（4）您访问和管理个人信息的方式发生变化； ",
          },
          {
            name: "（5）数据安全能力、信息安全风险发生变化； ",
          },
          {
            name: "（6）用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联络方式发生变化； ",
          },
          {
            name: "（7）其他可能对您的个人信息权益产生重大影响的变化。 ",
          },
          {
            name: "对于政策明发生重大变化，我们会通过不同渠道向您发送变更通知，包括但不限于网站公示、私信通知、App 推送等方式。 ",
          },
          {
            name: "九、如何联系我们",
          },
          {
            name: "当您对本政策有任何疑问，可以发送邮件至team#baishulai.com咨询（请将#号替换成@符号），我们将及时解决您的问题。 ",
          },
          {
            name: "<small>注：本《隐私政策》版本于2019年1月1日生效。</small>",
          },
        ],
      },
    ],
  },
};

export const help2 = {
  list: [
    {
      name: "品牌介绍",
      children: help.help.content1,
    },
    {
      name: "商务合作",
      children:  help.help.content2,
    },
    {
      name: "玩转爱答卷",
      children:  help.help.content3,
    },
    {
      name: "账户问题",
      children:  help.help.content4,
    },
    {
      name: "调查问题",
      children:  help.help.content5,
    },
    {
      name: "兑换问题",
      children:  help.help.content6
    },
    {
      name: "其他问题",
      children:  help.help.content7,
    },
  ],
};
